import { useChannelTalk } from '@repo/channel-talk';

import Layout from '@/components/layout/Layout';
import UnexpectedError from '@/components/tax-refund/common/view/ErrorView/UnexpectedError';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const ResultRequestEtcErrorPage = () => {
  const { openChannelTalk } = useChannelTalk();

  const handleAsk = () => {
    openChannelTalk(SUPPORT_BOT_LINK.errors);
  };

  return (
    <Layout>
      <UnexpectedError onPrimaryButtonClick={handleAsk} />
    </Layout>
  );
};

export default ResultRequestEtcErrorPage;
